(() => {
  const NativeInspirations = customElements.get('bb-product-inspirations');
  if (!NativeInspirations || customElements.get('bb-classique-inspirations')) return;

  customElements.define('bb-classique-inspirations', class extends NativeInspirations {
    connectedCallback() {
      if (!this.sampled) {
        const template = this.querySelector('[data-inspiration-cards]');
        if (!template) return;
        const sourceKey = card => card.querySelector('img')?.getAttribute('src')?.split('?')[0];
        const seen = new Set();
        const candidates = [...template.content.children].filter(card => {
          const key = sourceKey(card);
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        const storageKey = 'blankabric:classique:inspirations:last';
        let previous = new Set();
        try {
          const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
          if (Array.isArray(saved)) previous = new Set(saved);
        } catch { /* Sampling also works when storage is unavailable. */ }
        const shuffle = cards => {
          const shuffled = [...cards];
          for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
          }
          return shuffled;
        };
        const selected = [];
        const products = new Set();
        const pick = (pool, limit) => {
          const ordered = [...shuffle(pool.filter(card => !previous.has(sourceKey(card)))), ...shuffle(pool.filter(card => previous.has(sourceKey(card))))];
          let picked = 0;
          // Prefer different fabrics; use a second inspiration only when needed.
          for (const allowRepeat of [false, true]) {
            for (const card of ordered) {
              if (picked >= limit) return;
              if (selected.includes(card) || (!allowRepeat && products.has(card.dataset.sourceProduct))) continue;
              selected.push(card);
              products.add(card.dataset.sourceProduct);
              picked++;
            }
          }
        };
        pick(candidates.filter(card => card.dataset.inspirationGroup === 'white'), 5);
        pick(candidates.filter(card => card.dataset.inspirationGroup === 'printed'), 5);
        if (selected.length < 10) pick(candidates, 10 - selected.length);
        template.content.replaceChildren(...shuffle(selected));
        this.sampled = true;
        try { sessionStorage.setItem(storageKey, JSON.stringify(selected.map(sourceKey))); } catch { /* Optional history only. */ }
        const opener = this.querySelector('[data-inspiration-open]');
        if (opener) opener.hidden = !selected.length;
        const preview = this.querySelector('[data-bb-inspiration-preview]');
        const firstSource = template.content.firstElementChild?.querySelector('img')?.getAttribute('src');
        if (preview && firstSource) {
          const previewURL = new URL(firstSource, location.href);
          if (previewURL.hostname === 'cdn.shopify.com' || previewURL.pathname.startsWith('/cdn/shop/')) previewURL.searchParams.set('width', '180');
          preview.dataset.previewSrc = previewURL.href;
          if (preview.hasAttribute('src')) preview.src = previewURL.href;
        }
      }
      super.connectedCallback();
    }
  });
})();
